import React from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  HStack,
  Text,
  Icon,
  Box,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import { Organization } from '../../utils/types';

type OrganizationDropdownProps = {
  organizations: Organization[];
  selectedOrgId: string;
  onSelectOrg: (org: Organization) => void;
  onClose: () => void;
};

const SubscriptionBadge = ({ type }: { type: string }) => {
  let colorScheme = 'gray';
  if (type === 'Free') colorScheme = 'gray';
  else if (type === 'Starter') colorScheme = 'green';
  else if (type === 'Pro') colorScheme = 'green';
  else if (type === 'Enterprise') colorScheme = 'green';

  return (
    <Box
      as="span"
      px={2}
      py={0.5}
      borderRadius="md"
      fontSize="xs"
      fontWeight="bold"
      color={`${colorScheme}.700`}
      bg={`${colorScheme}.100`}
      userSelect="none"
    >
      {type}
    </Box>
  );
};

const OrganizationDropdown: React.FC<OrganizationDropdownProps> = ({
  organizations,
  selectedOrgId,
  onSelectOrg,
  onClose,
}) => {
  const selectedOrg = organizations.find((org) => org.id === selectedOrgId) || organizations[0];
  let navigate = useNavigate(); 

  return (
    <>
    {
      organizations.length<1 && 
      <Button onClick={()=>{onClose(); navigate('/new-organization');}}>
      Create New Organization
    </Button>
    }
    {
      organizations.length>0 &&
    <Menu>
      <MenuButton as={Button} rightIcon={<ChevronDownIcon />} w="250px" textAlign="left">
        <HStack spacing={3}>
          {/* {selectedOrg.icon && <Icon as={() => selectedOrg.icon} boxSize={5} />} */}
          <Text fontSize="small" maxW="180px" isTruncated>{selectedOrg?.name}</Text>
          <SubscriptionBadge type={selectedOrg?.subscription?.tier_display || ''} />
        </HStack>
      </MenuButton>

      <MenuList>
        {organizations.map((org) => {
          const isSelected = org.id === selectedOrgId;
          return (
            <MenuItem
              key={org.id}
              onClick={() => onSelectOrg(org)}
              bg={isSelected ? 'green.100' : undefined}
              _hover={{ bg: isSelected ? 'green.200' : 'gray.100' }}
              color={isSelected ? 'green.800' : undefined}
            >
              <HStack spacing={3} w="100%">
                {/* {org.icon && <Icon as={() => org.icon} boxSize={5} />} */}
                <Text flex="1" fontWeight={isSelected ? 'bold' : 'normal'}>
                  {org.name}
                </Text>
                <SubscriptionBadge type={org?.subscription?.tier_display || ''} />
              </HStack>
            </MenuItem>
          );
        })}
        <MenuItem
          key={'123'}
          onClick={()=>{onClose(); navigate('/new-organization');}}
        >
          Create New Organization
        </MenuItem>
      </MenuList>
    </Menu>
    }
    </>
  );
};

export default OrganizationDropdown;
